import { Selector } from '@ngxs/store';
import { MessagesExtensionsFR } from './app.config.types';
import { AppState } from './app.state';
import { AppStateModel, SCREEN_SIZE } from './app.state.models';

export class AppSelectors {
  @Selector([AppState])
  static userInfos(state: AppStateModel): any {
    return state.userInfos;
  }

  @Selector([AppState])
  static isWidthScreenLTE1200(state: AppStateModel): any {
    return state.widthScreen <= 1200;
  }
  @Selector([AppState])
  static showLoader(state: AppStateModel): boolean {
    return state.showLoader > 0;
  }

  @Selector()
  static isIPHONE(): boolean {
    return /iPhone/i.test(navigator.userAgent);
  }

  @Selector()
  static isIPAD(): boolean {
    return /iPad/i.test(navigator.userAgent);
  }

  @Selector()
  static isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }

  @Selector([AppState])
  static selectScreenWidthSize(state: AppStateModel): SCREEN_SIZE {
    return state.screenWidthSize;
  }

  @Selector([AppState])
  static messagesExtensionsFrontReader(state: AppStateModel): MessagesExtensionsFR {
    return state.messagesExtensionsFrontReader;
  }
}
